// MODE_LABEL_GLYPHS — generated by scripts/extract-glyphs.py. DO NOT hand-edit.
// Satoshi-Bold (700) glyph outlines, one <path> per letter, laid out with the
// logo's 0.04em tracking, y-flipped into SVG space (baseline at y=0). Coordinates
// are in font units (unitsPerEm=1000). Source font: Satoshi-Bold.woff2.
// Regenerate: scripts/doc-tools/extract-glyphs.py --name MODE_LABEL_GLYPHS Skat Ramsch | npx prettier --parser babel

export const MODE_LABEL_GLYPHS = {
  Skat: {
    viewBox: "-40 -1010 2218 1250",
    glyphs: [
      {
        ch: "S",
        d: "M39 -527Q39 -623 111.5 -683.5Q184 -744 299 -744Q410 -744 476.0 -686.5Q542 -629 545 -530H417Q415 -577 383.0 -603.5Q351 -630 297 -630Q238 -630 202.5 -603.5Q167 -577 167 -531Q167 -456 256 -436L371 -411Q557 -371 557 -211Q557 -109 484.0 -48.0Q411 13 290 13Q173 13 102.0 -45.0Q31 -103 29 -201H157Q158 -155 193.0 -128.5Q228 -102 290 -102Q354 -102 391.5 -128.0Q429 -154 429 -200Q429 -273 344 -291L228 -317Q39 -358 39 -527Z",
      },
      {
        ch: "k",
        d: "M818.0 0H697.0V-744H818.0V-287L1010.0 -494H1163.0L975.0 -298L1159.0 0H1019.0L890.0 -208L818.0 -133Z",
      },
      {
        ch: "a",
        d: "M1420.0 13Q1342.0 13 1296.5 -29.0Q1251.0 -71 1251.0 -141Q1251.0 -209 1298.5 -250.0Q1346.0 -291 1434.0 -298L1582.0 -309V-320Q1582.0 -414 1480.0 -414Q1426.0 -414 1397.0 -392.5Q1368.0 -371 1368.0 -332H1264.0Q1264.0 -412 1324.5 -460.5Q1385.0 -509 1486.0 -509.0Q1587.0 -509 1644.0 -455.0Q1701.0 -401 1701.0 -300V0H1594.0L1585.0 -73Q1569.0 -35 1523.5 -11.0Q1478.0 13 1420.0 13ZM1460.0 -79Q1517.0 -79 1550.0 -111.0Q1583.0 -143 1583.0 -200V-226L1480.0 -218Q1375.0 -208 1375.0 -146Q1375.0 -79 1460.0 -79Z",
      },
      {
        ch: "t",
        d: "M2029.0 0H1907.0V-392H1812.0V-494H1907.0V-648H2029.0V-494H2125.0V-392H2029.0Z",
      },
    ],
  },
  Ramsch: {
    viewBox: "-40 -1010 3985 1250",
    glyphs: [
      {
        ch: "R",
        d: "M209 0H81V-731H360Q485 -731 554.0 -671.0Q623 -611 623 -503Q623 -354 491 -300L630 0H490L366 -273H209ZM209 -617V-386H360Q421 -386 455.0 -417.0Q489 -448 489 -503Q489 -557 455.0 -587.0Q421 -617 360 -617Z",
      },
      {
        ch: "a",
        d: "M920.0 13Q842.0 13 796.5 -29.0Q751.0 -71 751.0 -141Q751.0 -209 798.5 -250.0Q846.0 -291 934.0 -298L1082.0 -309V-320Q1082.0 -414 980.0 -414Q926.0 -414 897.0 -392.5Q868.0 -371 868.0 -332H764.0Q764.0 -412 824.5 -460.5Q885.0 -509 986.0 -509.0Q1087.0 -509 1144.0 -455.0Q1201.0 -401 1201.0 -300V0H1094.0L1085.0 -73Q1069.0 -35 1023.5 -11.0Q978.0 13 920.0 13ZM960.0 -79Q1017.0 -79 1050.0 -111.0Q1083.0 -143 1083.0 -200V-226L980.0 -218Q875.0 -208 875.0 -146Q875.0 -79 960.0 -79Z",
      },
      {
        ch: "m",
        d: "M1483.0 0H1361.0V-494H1473.0L1483.0 -436Q1528.0 -509 1629.0 -509Q1739.0 -509 1782.0 -415Q1801.0 -458 1843.0 -483.5Q1885.0 -509 1940.0 -509Q2029.0 -509 2077.5 -459.5Q2126.0 -410 2126.0 -323V0H2005.0V-291Q2005.0 -343 1979.0 -371.0Q1953.0 -399 1909.0 -399Q1863.0 -399 1834.0 -368.5Q1805.0 -338 1805.0 -280V0H1683.0V-292Q1683.0 -343 1657.5 -370.5Q1632.0 -398 1588.0 -398Q1542.0 -398 1512.5 -367.5Q1483.0 -337 1483.0 -280Z",
      },
      {
        ch: "s",
        d: "M2248.0 -150H2364.0Q2365.0 -117 2388.0 -98.5Q2411.0 -80 2453.0 -80.0Q2495.0 -80 2518.0 -96.0Q2541.0 -112 2541.0 -139Q2541.0 -179 2484.0 -192L2395.0 -213Q2327.0 -228 2295.0 -261.5Q2263.0 -295 2263.0 -354Q2263.0 -426 2317.5 -467.5Q2372.0 -509 2459.0 -509Q2542.0 -509 2593.5 -465.0Q2645.0 -421 2646.0 -349H2530.0Q2529.0 -381 2509.0 -399.5Q2489.0 -418 2454.0 -418Q2418.0 -418 2398.0 -402.5Q2378.0 -387 2378.0 -359Q2378.0 -318 2442.0 -303L2531.0 -282Q2595.0 -267 2625.5 -236.0Q2656.0 -205 2656.0 -149Q2656.0 -75 2599.0 -31.0Q2542.0 13 2449.0 13Q2357.0 13 2302.5 -32.0Q2248.0 -77 2248.0 -150Z",
      },
      {
        ch: "c",
        d: "M2760.0 -248Q2760.0 -363 2829.0 -436.0Q2898.0 -509 3007.0 -509Q3108.0 -509 3172.5 -456.5Q3237.0 -404 3247.0 -315H3125.0Q3104.0 -400 3012.0 -400Q2953.0 -400 2917.5 -358.5Q2882.0 -317 2882.0 -248Q2882.0 -178 2916.0 -137.5Q2950.0 -97 3008.0 -97Q3054.0 -97 3084.5 -119.0Q3115.0 -141 3125.0 -181H3248.0Q3237.0 -94 3170.5 -40.5Q3104.0 13 3008.0 13Q2896.0 13 2828.0 -58.5Q2760.0 -130 2760.0 -248Z",
      },
      {
        ch: "h",
        d: "M3501.0 0H3379.0V-744H3502.0V-430Q3526.0 -467 3568.0 -488.0Q3610.0 -509 3662.0 -509Q3752.0 -509 3800.0 -455.0Q3848.0 -401 3848.0 -304V0H3726.0V-275Q3726.0 -336 3698.5 -367.0Q3671.0 -398 3623.0 -398Q3566.0 -398 3533.5 -362.5Q3501.0 -327 3501.0 -270Z",
      },
    ],
  },
};
